import { useRoute } from "vue-router";
import { computed } from "vue";

export const useBleDeviceId = () => {
  const route = useRoute();
  console.log("route", route);
  return computed(() => (route?.params.poolId as string)?.split("ble:")?.[1]);
};
